import { Box } from "@mui/material";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import { useEffect, useState } from "react";
import { Loading } from "shared-ui/global/Loading";
import { useEnvironmentType } from "../../contexts/useEnvType";
import { environment } from "../../environment";
import { useUser } from "../../utils/tokens";
import { AuthRouter } from "./AuthRouter";
import { getOrgUserDetails } from "./OrgUtils";

export const AuthRouterWithLDProvider = () => {
  const user = useUser();
  const { isTactical } = useEnvironmentType();
  const [LDProvider, setLDProvider] = useState<React.ComponentType<{ children: React.ReactNode }> | null>(null);

  useEffect(() => {
    if (isTactical) return;
    const initializeLDProvider = async () => {
      try {
        const { isStaff, orgId, orgName, userId, userName } = getOrgUserDetails(user);
        if (!isStaff && !orgId && orgName && !userId && !userName) {
          throw new Error("Invalid user");
        }
        const provider = await asyncWithLDProvider({
          clientSideID: environment.VITE_LD_FLAGS_CLIENT_ID,
          context: {
            kind: "multi",
            organization: {
              key: isStaff ? "staff" : orgId,
              name: isStaff ? "staff" : orgName,
            },
            user: {
              key: userId,
              name: userName,
            },
          },
        });
        setLDProvider(() => provider);
      } catch (error) {
        console.error("Failed to initialize LaunchDarkly provider:", error);
      }
    };
    initializeLDProvider();
  }, [isTactical]);

  if (isTactical) {
    return <AuthRouter />;
  }

  return !LDProvider ? (
    <Box sx={{ height: "100vh", width: "100vw" }}>
      <Loading />
    </Box>
  ) : (
    <LDProvider>
      <AuthRouter />
    </LDProvider>
  );
};
